// extracted by mini-css-extract-plugin
export default {"welcome":"Home_welcome__X+AaN","login":"Home_login__h8MtU","signup-Header":"Home_signup-Header__DYjxD","home":"Home_home__Iy41P"};